import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  Grid,
  Button,
  Typography
} from '@material-ui/core'
import defaultAvatar from '../../../assets/images/avatar-placeholder.png'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import IconButton from '@material-ui/core/IconButton'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'

const useStyles = makeStyles((theme) => ({
  input: {
    display: 'none',
  },
  avatar: {
    width: '50px',
    height: '50px',
    borderRadius: '50%'
  },
  fileName: {
    whiteSpace: 'nowrap',
    width: 'auto',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: 'rgb(118, 118, 118)',
    marginLeft: '1px'
  }
}))

const AvatarUpload = ({handleAvatar, avatar, setIsCropping}) => {
  const classes = useStyles()
  const [fileName, setFileName] = useState('')

  const avatarNotDefault = () => {
    return (avatar !== defaultAvatar)
  }

  const resetAvatar = () => {
    handleAvatar(defaultAvatar)
    setFileName('')
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    const reader = new FileReader()

    reader.addEventListener('load', () => {
      handleAvatar(reader.result)
      setIsCropping(true)
    }, false)

    if (file) {
      reader.readAsDataURL(file)
      setFileName(file.name)
    }
  }

  return(
    <Grid container spacing={0}>
      <Grid item xs={8} container direction='column' spacing={1}>
        <Grid item container justifyContent='flex-start'>
          <input
            type='file'
            name='avatar'
            accept='image/png, image/jpeg'
            id='contained-button-file'
            className={classes.input}
            onChange={handleFileChange}
            onClick={e => (e.target.value = null)}
          />
          <label htmlFor="contained-button-file">
            <Button
              variant='outlined'
              color='secondary'
              component='span'
              startIcon={<CloudUploadIcon />}
            >
              Profile Image
            </Button>
          </label>
        </Grid>
        <Grid item container justifyContent='flex-start'>
          <Typography variant='caption' className={classes.fileName}>{fileName}</Typography>
        </Grid>
      </Grid>
      <Grid item xs={2}>
        <img src={avatar} className={classes.avatar}/>
      </Grid>
      <Grid container item xs={2} alignItems='center'>
        {avatarNotDefault() &&
          <IconButton onClick={resetAvatar} size='small'>
            <DeleteForeverIcon color='secondary' fontSize='small'/>
          </IconButton>
        }
      </Grid>
    </Grid>
  )
}

export default AvatarUpload
